import React from 'react'
// import moment from 'moment'
import { DateUtil, TIME } from '@utils'
import { Editable, IconButton, PrettyDate, prettyDate } from '@ui'
import { FormGroup, Intent, Position } from '@blueprintjs/core'
import { DateInput2 } from '@blueprintjs/datetime2'
import Label from './Label'

interface IProps {
  colorize?: boolean
  append?: JSX.Element | null
  required?: boolean
  error: string
  editing: boolean
  label: string
  value: any
  onChange: (val: any) => void
  'data-input'?: string
}

export default function DateDetails({
  colorize,
  append = null,
  error,
  editing,
  required,
  label,
  value,
  onChange,
  'data-input': dataInput,
}: IProps) {
  const rightElement = value ? (
    <IconButton minimal iconName="times" onClick={() => onChange(null)} />
  ) : undefined

  const intent = error ? Intent.DANGER : undefined
  return (
    <>
      <Label {...{ label, editing, required }} />
      <Editable editing={editing} style={{ width: editing ? 130 : 100 }}>
        <PrettyDate {...{ colorize, value, 'data-input': dataInput }} />
        <FormGroup {...{ helperText: error, intent }}>
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
          {/* @ts-ignore */}
          <DateInput2
            {...{
              value,
              onChange,
              inputProps: {
                rightElement,
                intent,
                style: { width: 135 },
                'data-input': dataInput,
              },
            }}
            popoverProps={{ minimal: true, position: Position.BOTTOM }}
            formatDate={(value) => prettyDate({ value })}
            parseDate={(date: string) => DateUtil(date).toDate()}
            maxDate={DateUtil().add(25, TIME.YEARS).toDate()}
          />
        </FormGroup>
      </Editable>
      {append}
    </>
  )
}
